import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { siteSpecificData } from '../../../environments/site-specific-data'
import { Observable } from 'rxjs';
import { UnitDetails } from "../models/unit-details"
const API_URL = siteSpecificData.apiUrlBase;

@Injectable()
export class UnitDetailsService {
  constructor(private http: HttpClient) { }

  getUnitByRef(propertyRef: number, unitRef: number): Observable<UnitDetails> {
    let unitByRefUrl = `${API_URL}property/${propertyRef}/unit/${unitRef}/details`;
    return this.http.get<UnitDetails>(unitByRefUrl);
  }

}
